import { BasePresenter } from "@presenters/base/base.presenter";
import { useSelector } from "react-redux";
import { dxDataGridColumn } from 'devextreme/ui/data_grid';
import { Utilities, String, Constants, Enums, queryString, Dictionary } from "@utils";
import DataGrid from "devextreme/ui/data_grid";
import {IBudgetFormBasicDataMasters, IPProaBeneficiariosDuplicados } from "@models/*";
import { IProaService, ProaService} from "@services/proyecta/proa-form.service";
import { IProjectBeneficiaries } from "@interfaces/screens/beneficiaries.interface";
import { ProaSummaryPresenter } from '@presenters/screens/proa-summary.presenter';

export class ProjectBeneficiariesPresenter extends BasePresenter<IProjectBeneficiaries> {
  private _tableId: string = 'project-beneficiaries';
  private _tableIdTemplate: string = 'project-detail';
  private _service: IProaService;
  public formMasters: IBudgetFormBasicDataMasters;
  public _viewMode: boolean = false;
  public currentLabels: Dictionary<string, string>;

  constructor(view: IProjectBeneficiaries) {
    super(view);
    this._service = new ProaService();
    this.initialize();
    this._viewMode = window.location.href.includes("view");
  }

  public initialize() {
    this.formMasters = useSelector(this.context.proaStore.selectFormMasters);
    this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
  }

  private getBudgetId() {
    const query = queryString.parseUrl(window.location.href.replace("#", ""))
      .query as any;
    return query.Id;
  }

  public getSummaryYears(years: number[], dataYears: string[]) {
    const columns: Array<any> = [];
    let min: number = years[0];
    let max: number = years[years.length - 1];

    for (let index = min; index < max + 1; index++) {
      dataYears.forEach(dataField => {
        let format = (dataField.includes("NotValue")) ? "-" : "{0}"
        dataField = dataField.replace("NotValue", "")

        const col: any = {};
        col.column = String.Format(`${dataField.replace("Duplicate", "")}{0}`, index);
        col.name = String.Format(`${dataField}{0}`, index);
        col.summaryType = 'custom';
        col.displayFormat = format;
        col.valueFormat = Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL
        columns.push(col);
      });
    }
        
    return columns;
  }

  public getSummary(years: number[]) {
    let dataYears = ["beneficiaries", "beneficiariesMensDuplicate", "beneficiariesMens", "beneficiariesWomensDuplicate", "beneficiariesWomens", "totalDup", "totalNotValue", "total"];

    return [
      { column: "subProject", summaryType: 'custom', displayFormat:this.currentLabels.get("TotalesDupProyecto"), name: "notValue" },
      { column: "subProject", summaryType: 'custom', displayFormat:this.currentLabels.get("TotalesProyecto"), name: "notValue" },
      { column: "beneficiaries", summaryType: 'custom', name:"beneficiaries", displayFormat:"{0}", valueFormat: Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL },
      ...this.getSummaryYears(years, dataYears),
      { column: "totalDupProject", summaryType: 'custom', name:"totalDupProject", displayFormat:"{0}", valueFormat: Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL },
      { column: "totalProject", summaryType: 'custom', name:"notValue", displayFormat:"-", valueFormat: Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL },
      { column: "totalProject", summaryType: 'custom', name:"totalProject", displayFormat:"{0}", valueFormat: Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL },
    ]
  }

  public getData = async(basicData: any[], projects: any[], duplicatesSP: any[]) => {
    let auxData: any[] = [];
    let duplicatesData: any[] = [];
    let years: number[] = [];

    basicData.map((data: any) => {
      let sumDup = (data.PFFRRTotalHombres || 0) + (data.PFRRTotalMujeres || 0);
      if(!years.includes(parseInt(data.PPresuAnio)) && sumDup) years.push(parseInt(data.PPresuAnio))
    })
    years = years.sort((a, b) => ((a < b) ? -1 : ((a > b) ? 1 : 0)));

    let summaryConfig = this.getSummary(years);

    projects.forEach((subProj: any) => {
      let subProject = subProj.PPresCodSubvencionId ? subProj.PPresCodSubvencion.Title : "FFRR"
      let codeSubId = (subProject !== "FFRR") ? this.formMasters.grantCodes.find((code: any) => code.OCTAVIACodigoSubvencion === subProject)?.Id : null

      let obj: any = {
        ID: subProj.Id,
        subProject,
        codeSubId,
        beneficiaries: 0
      }
      let duplicates: any = {
        ID: subProj.Id,
        subProject,
        codeSubId,
      }
      basicData.map((sub: any) => {
        if(subProj.Id === sub.PProaFRStep1Id){
          obj.beneficiaries = obj.beneficiaries + (sub.PFFRRTotalHombres || 0) + (sub.PFRRTotalMujeres || 0);

          const parameterNameT = String.Format("beneficiaries{0}", sub.PPresuAnio);
          const parameterNameH = String.Format("beneficiariesMens{0}", sub.PPresuAnio);
          const parameterNameM = String.Format("beneficiariesWomens{0}", sub.PPresuAnio);

          obj[parameterNameH] =  (sub.PFFRRTotalHombres || 0);
          obj[parameterNameM] =  (sub.PFRRTotalMujeres || 0);
          obj[parameterNameT] =  (sub.PFFRRTotalHombres || 0) + (sub.PFRRTotalMujeres || 0);

          duplicates[parameterNameH] = null;
          duplicates[parameterNameM] = null;

        }
      })

      if(subProj.PPresCodSubvencionId && subProject){ auxData.push(obj); duplicatesData.push(duplicates); }
      else if(!subProj.PPresCodSubvencionId && subProject){ auxData.unshift(obj); duplicatesData.unshift(duplicates); }
      
    });

    let yearMin = years[0];
    let yearMax = years[years.length - 1];

    auxData.map((data: any) => {
      let pivot: any = null;
      let auxDuplicates: any[] = duplicatesData.filter((dup:any )=> {
        if(pivot) return dup;
        if(dup.ID === data.ID) pivot = dup
      })
      let addYears = 0;
      let addYearsDup = 0;
       if(!auxDuplicates.length){
        for (let index = yearMin; index <= yearMax; index++) {
          data[`total${index}`] = (data[`beneficiaries${index}`] || 0)
        }
          data["totalProject"] = (data["beneficiaries"] || 0)
      }

      for (let index = yearMin; index <= yearMax; index++) {
        let sumDuplicados = 0;
        auxDuplicates.forEach(dupfind => {
          let dupFindSP = duplicatesSP.find((dupSP: any) => dupSP.PPresCodSubvencionId === dupfind.codeSubId && dupSP.PPresuAnio == index && pivot.ID == dupSP.PProaFRStep1Id)
          let DuplicateMens = dupFindSP ? (dupFindSP.PFFRRTotalHombres || 0) : (dupfind[`beneficiariesMens${index}`] || 0)
          let DuplicateWomens = dupFindSP ? (dupFindSP.PFRRTotalMujeres || 0) : (dupfind[`beneficiariesWomens${index}`] || 0)

          sumDuplicados += (DuplicateMens + DuplicateWomens)
        });
        data[`total${index}`] = data[`beneficiaries${index}`] ? ((data[`beneficiaries${index}`] || 0) - sumDuplicados) : null
        addYears = addYears + data[`total${index}`]
        data[`totalDup${index}`] = sumDuplicados || null
        addYearsDup = addYearsDup + data[`totalDup${index}`]
      }
      data["totalProject"] = addYears
      data["totalDupProject"] = addYearsDup
      return data; 
    })

    this.view.state.setYears(years);
    this.view.state.setDataSource(auxData);
    this.view.state.setBasicData(basicData);
    this.view.state.setDuplicatesSP(duplicatesSP);
    this.view.state.setSummaryConfig(summaryConfig);
    this.view.state.setColumns(this.getReportColumns(years));
  }

  public getDataDetails = (detail: any) =>{
    let dataSource = Utilities.copyObject(this.view.state.dataSource);
    let dataDetail: any[] = [];
    let auxData: any[] = [];
    let pivot: any = null;

    dataSource.map((dup: any) => {
      if(pivot) auxData.push(dup) 
      if(dup.ID === detail.ID) pivot = dup
    })


    auxData.forEach(data => {
      let duplicatesObj: any = {
        ID: data.ID,
        subProject: data.subProject,
      }

      let yearMin = this.view.state.years[0];
      let yearMax = this.view.state.years[this.view.state.years.length - 1];
      for (let index = yearMin; index <= yearMax; index++) {
        let dupFind = this.view.state.duplicatesSP.find((dupSP: any) => (dupSP.PPresCodSubvencionId === data.codeSubId && dupSP.PPresuAnio == index && pivot.ID == dupSP.PProaFRStep1Id) )
        const parameterNameH = String.Format("beneficiariesMens{0}", index);
        const parameterNameM = String.Format("beneficiariesWomens{0}", index);
        duplicatesObj[parameterNameH] =  dupFind ? dupFind.PFFRRTotalHombres : null;
        duplicatesObj[parameterNameM] =  dupFind ? dupFind.PFRRTotalMujeres : null;
      }
      dataDetail.push(duplicatesObj)
    })
    return {dataSource: dataDetail, columns: this.getReportColumnsDetails(this.view.state.years)};
  }

  public validateCell = (e: any, pivot:any, dataDetail:any) => {
    
    let myData = this.view.state.dataSource.find((x: any) => x.ID === e.data.ID)
    let result: boolean = (e.value <= (pivot[e.column.dataField] || 0) && e.value <= (myData[e.column.dataField] || 0))

    return result;
  };

  public saveDetail = async (newDuplicates: any, pivot: any, summaryPresenter: ProaSummaryPresenter) => {
    let stateDuplicates = this.view.state.duplicatesSP;
    let masterData = Utilities.copyObject(this.view.state.dataSource);
    let yearMin = this.view.state.years[0];
    let yearMax = this.view.state.years[this.view.state.years.length - 1];
    let saveObjects: any[] = [];

    masterData.map((data: any) => {
      if(data.ID === pivot.ID){
        let addYears = 0;
        let addYearsDup = 0;
        for (let index = yearMin; index <= yearMax; index++) {
          let sumDuplicados = 0;
          newDuplicates.forEach((dupfind: any) => {
            let codeSub = (dupfind.subProject !== "FFRR") ? this.formMasters.grantCodes.find((code: any) => code.OCTAVIACodigoSubvencion === dupfind.subProject)?.Id : null;
            let DuplicateMens = (dupfind[`beneficiariesMens${index}`] || 0)
            let DuplicateWomens = (dupfind[`beneficiariesWomens${index}`] || 0)

            sumDuplicados += (DuplicateMens + DuplicateWomens)
            
            let item: IPProaBeneficiariosDuplicados = {
              PPresPresupuestoId:  parseInt(this.getBudgetId()),
              PPresCodSubvencionId: codeSub,
              PFFRRTotal: (DuplicateMens + DuplicateWomens) || null,
              PFFRRTotalHombres: DuplicateMens || null,
              PFRRTotalMujeres: DuplicateWomens || null,
              PPresuAnio: index.toString(),
              PProaFRStep1Id: pivot.ID,
            }

            saveObjects.push(item)
          });
          data[`total${index}`] = data[`beneficiaries${index}`] ? ((data[`beneficiaries${index}`] || 0) - sumDuplicados) : null
          addYears = addYears + data[`total${index}`]
          data[`totalDup${index}`] = sumDuplicados || null
          addYearsDup = addYearsDup + data[`totalDup${index}`]
        }
        data["totalProject"] = addYears
        data["totalDupProject"] = addYearsDup
      }
      return data;
    })
    
    let newDuplicatesSP = stateDuplicates.map((dupSp: any) => {
      let objFind = saveObjects.find(auxObj => dupSp.PPresCodSubvencionId == auxObj.PPresCodSubvencionId && dupSp.PProaFRStep1Id == auxObj.PProaFRStep1Id && dupSp.PPresuAnio == auxObj.PPresuAnio)
      return objFind ? objFind : dupSp;
    })
    saveObjects.map(auxObj => {
      let objFind = newDuplicatesSP.find((dupSp: any) => auxObj.PPresCodSubvencionId == dupSp.PPresCodSubvencionId && auxObj.PProaFRStep1Id == dupSp.PProaFRStep1Id && auxObj.PPresuAnio == dupSp.PPresuAnio)
      if(!objFind) newDuplicatesSP.push(auxObj)
    })

    summaryPresenter.view.state.setBeneficiariesDuplicates(newDuplicatesSP);
    this.view.state.setDuplicatesSP(newDuplicatesSP);
    this.view.state.setDataSource(masterData);
  }

  public getGridProps() {
    let internalProps: any = {
      id: this._tableId,
      showRowLines: true,
      columnWidth: 140,
      width: "100%",
      stateStoring: {
        enabled: false,
        type: "localStorage",
        // storageKey: "storage_" + this._tableId
      },
      toolbar: {
        title: this.currentLabels.get("SuperposicionTitle"),
      },
      allowColumnResizing: true,
      columnResizingMode: "widget",
      wordWrapEnabled: true,
      columnFixing: { enabled: true },
    };

    internalProps.onToolbarPreparing = (e: any) => onToolbarPreparing({ e: e, component: this.getDataFromTable(internalProps.id) });

    let onToolbarPreparing = (e: any) => {  };

    return { ...internalProps };
  }

  public getGridPropsDetails(pivot: any) {
    let internalProps: any = {
      id: `${this._tableIdTemplate}-${pivot.ID}`,
      showRowLines: true,
      columnMinWidth: 140,
      width: "100%",
      editing: { mode: "cell", allowUpdating: true, allowAdding: false, allowDeleting: false, useIcons: true },
      stateStoring: {
        enabled: false,
        type: "localStorage",
        // storageKey: "storage_" + this._tableIdTemplate
      },
      allowColumnResizing: true,
      columnResizingMode: "widget",
      wordWrapEnabled: true,
      columnFixing: { enabled: true },
      loadPanel: {
        enabled:"auto",
        showIndicator:false,
        showPane:false,
        text: ""
      },
    };

    internalProps.onToolbarPreparing = (e: any) => onToolbarPreparing({ e: e, component: this.getDataFromTable(internalProps.id) });

    let onToolbarPreparing = (e: any) => {  };

    return { ...internalProps };
  }

  private getDataFromTable(tableId: string): DataGrid {
    let element = document.getElementById(tableId);
    if (Utilities.isNullEmptyObject(element)) {
      return null;
    }

    return DataGrid.getInstance(element) as DataGrid;
  }

  private getDataSourceFromTable(tableId: string): Array<any> {
    let element = document.getElementById(tableId);
    if (Utilities.isNullEmptyObject(element)) {
      return [];
    }

    let instance = DataGrid.getInstance(element) as DataGrid;
      return instance.getDataSource().items();
  }

  private getYearsColumns(years: number[], dataYears: any[], detail?: boolean) {
    let globalYears = this.view.state.years || years;
    const columns: Array<any> = [];
    let min: number = globalYears[0];
    let max: number = globalYears[globalYears.length - 1];

    for (let index = min; index < max + 1; index++) {
      dataYears.forEach(element => {
        const column: any = {};
        column.caption = String.Format(`${element.field} {0}`, index);
        column.dataField = String.Format(`${element.dataField}{0}`, index);
        column.visible = years.includes(index);
        column.dataType = 'number';
        column.alignment = 'center';
        if(detail){
          column.readOnly = this._viewMode;
          column.validateDuplicates = true;
          column.validationErrorMessage = this.currentLabels.get("DuplicatesErrorMessage");
        }
        columns.push(column);
      });
    }
    return columns;
  }

  private getReportColumns(years: number[]) {
    let dataYears = [{field: this.currentLabels.get("BeneficiariosProyecto"), dataField:"beneficiaries"},
      {field: this.currentLabels.get("BeneficiariosHombres"), dataField:"beneficiariesMens"}, 
      {field: this.currentLabels.get("BeneficiariosMujeres"), dataField:"beneficiariesWomens"}, 
      {field: this.currentLabels.get("BeneficiariosTotalDup"), dataField: 'totalDup'},
      {field: this.currentLabels.get("BeneficiariosTotal"), dataField:"total"}];

    return <dxDataGridColumn[]>[
      {
        caption: this.currentLabels.get("SubProyecto"),
        dataField: 'subProject',
        visible: true,
        dataType: 'string',
        alignment: 'center',
        fixed: true,
        fixedPosition: "left",
      },
      {
        caption: this.currentLabels.get("BeneficiariosProyecto"),
        dataField: 'beneficiaries',
        visible: true,
        dataType: 'number',
        alignment: 'center',
      },
        ...this.getYearsColumns(years, dataYears),
      {
        caption: this.currentLabels.get("BeneficiariosTotalDupPr"),
        dataField: 'totalDupProject',
        visible: true,
        dataType: 'number',
        alignment: 'center',
      },
      {
        caption: this.currentLabels.get("BeneficiariosTotalPr"),
        dataField: 'totalProject',
        visible: true,
        dataType: 'number',
        alignment: 'center',
      },
    ];
  }

   public getReportColumnsDetails(years: number[]) {
    let dataYears = [{field: this.currentLabels.get("BeneficiariosHombres"), dataField:"beneficiariesMens"}, 
      {field: this.currentLabels.get("BeneficiariosMujeres"), dataField:"beneficiariesWomens"}];

    return <dxDataGridColumn[]>[
      {
        caption: this.currentLabels.get("SubProyecto"),
        dataField: 'subProject',
        visible: true,
        dataType: 'string',
        alignment: 'center',    
        readOnly: true,
        fixed: true,
        fixedPosition: "left",
      },
      ...this.getYearsColumns(years, dataYears, true),
    ];
  }

}   
